var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._b({staticClass:"stroke-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.height,"width":_vm.width,"viewBox":`0 0 ${_vm.height} ${_vm.width}`,"preserveAspectRatio":_vm.aspectRatio}},'svg',_vm.svgProps,false),[_c(_vm.iconComponent,_vm._b({tag:"component",attrs:{"size":_vm.size}},'component',_vm.iconProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }